<template>
	<div style="width: 100%;height: auto;">
		<video
			style="width: 100%; height: 100%"
			id="myVideo"
			class="video-js vjs-default-skin vjs-big-play-centered"
			webkit-playsinline
			playsinline
			x5-playsinline
			x-webkit-airplay="allow"
			x5-video-player-type="h5"
		></video>
	</div>
</template>

<script>
import Video from 'video.js/dist/video.js';
import zhCN from 'video.js/dist/lang/zh-CN.json';
import 'video.js/dist/video-js.css';

var myPlayer = '';
export default {
	props: {
		src: '',
		prevTiem: ''
	},
	data() {
		return {
			options: {
				//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
				controls: true,
				//自动播放属性,muted:静音播放
				autoplay: false,
				//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
				preload: 'auto',
				//设置视频播放器的显示宽度（以像素为单位）
				width: '375px',
				// 初始化时设置语言，立即生效
				language: 'zh-CN',
				// 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
				aspectRatio: '16:9',
				sources: []
			}
		};
	},
	computed: {
		isSwitchVideo() {
			return this.src + '' + this.prevTiem;
		}
	},
	watch: {
		// 视频切换
		isSwitchVideo(newValue, oldValue) {
			myPlayer.src(this.src);
			myPlayer.load(this.src);
			if (this.prevTiem) myPlayer.currentTime(Number(this.prevTiem));
		}
	},
	mounted() {
		this.initVideo();
	},
	methods: {
		initVideo() {
			//初始化视频方法
			Video.addLanguage('zh-CN', zhCN);
			myPlayer = Video(myVideo, this.options);
			myPlayer.src(this.src);
			myPlayer.ready(() => {
				console.log('播放器加载完毕');
				if (this.prevTiem) myPlayer.currentTime(Number(this.prevTiem));
			});
			myPlayer.on('timeupdate', () => {
				console.log('监听播放进度', myPlayer.currentTime(), myPlayer.duration());
				this.$emit('timeupdate', {
					currentTime: myPlayer.currentTime(),
					duration: myPlayer.duration()
				});
			});
			// 使用事件监听
			myPlayer.on('ended', () => {
				console.log('播放结束了!');
				this.$emit('ended', {
					currentTime: myPlayer.currentTime(),
					duration: myPlayer.duration()
				});
			});
		}
	}
};
</script>

<style>
.video-js .vjs-big-play-button {
	left: 0 !important;
	right: 0 !important;
	bottom: 0 !important;
	top: 0 !important;
	margin: auto !important;
}
</style>
